'use client';

import { Box, useTokens } from '@mezzoforte/forge';

interface StyleProps {
  displayDuration: number;
  numItems: number;
}

const { breakpoints } = useTokens.huutokaupat;

interface BannerItemProps {
  index: number;
  animate: boolean;
  children: React.ReactNode;
}

export function BannerItem({ index, animate, children }: BannerItemProps) {
  return (
    <Box
      as="span"
      sx={{
        gridArea: 'active',
        opacity: 0,
        ...(animate && {
          animation: `fadeInOut var(--display-duration) infinite, hideAfter calc(var(--display-duration) * var(--num-items)) infinite`,
          animationDelay: `calc(var(--display-duration) * ${index})`,
        }),
        [`@media screen and (min-width: ${breakpoints.lg})`]: {
          '&:not(:first-of-type):before': {
            content: '" | "',
            color: 'subdued',
            px: 'spacing2',
          },
          opacity: 1,
          animation: 'none',
        },
      }}
    >
      {children}
    </Box>
  );
}

interface BannerWrapperProps extends StyleProps {
  children: React.ReactNode;
  className?: string;
}

export function BannerWrapper({ displayDuration, numItems, children, className }: BannerWrapperProps) {
  return (
    <Box
      as="aside"
      className={className}
      style={
        {
          '--display-duration': `${displayDuration}ms`,
          '--num-items': numItems,
        } as React.CSSProperties
      }
      sx={{
        backgroundColor: '#20371c', // hex from brandSecondary with opacity .96
        color: 'textInvert',
        py: '2',
        '& a': {
          color: 'inherit',
          textDecoration: 'underline',
        },
        '& div': {
          display: 'grid',
          gridTemplateAreas: '"active"',
        },
        '@keyframes fadeInOut': {
          '0%, 100%': { opacity: 0 },
          '5%, 95%': { opacity: 1 },
        },
        '@keyframes hideAfter': {
          '0%': { visibility: 'visible' },
          [`${100 / numItems}%, 100%`]: { visibility: 'hidden' },
        },
        [`@media screen and (min-width: ${breakpoints.lg})`]: {
          '& div': {
            display: 'block',
          },
        },
      }}
    >
      {children}
    </Box>
  );
}
